import { useDispatch, useSelector } from "react-redux";
import {
  selectActiveWinery,
  selectAnalysis,
  selectStoredAnalysisResults,
  selectConfigs,
  selectDrugs,
  selectLots,
  selectOperations,
  selectTanks,
  selectTreatments,
  selectUsers,
  selectUserSockets,
  selectExams,
  selectOperationById,
  selectCompletedOperations,
  selectWineMaking,
} from "../../context/selectors";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import SecondaryBar from "../SecondaryBar";
import useLabels from "../../hooks/useLabels";
import { useEffect, useState } from "react";
import { socket } from "../../socket";
import {
  Button,
  ConfirmationModal,
  CTA,
  OperationRecap,
  Tooltip,
} from "../Generic";
import {
  addAnalysisSample,
  addOperationNote,
  completeOperation,
  deleteOperation,
  getAnalysisResults,
  getDrugs,
  getExams,
  getLots,
  getOperationById,
  getOperations,
  getOperationsByMainId,
  getPDF,
  getProtocols,
  getRepetitiveOperationsById,
  getTanks,
  getUsers,
  requestPDF,
  startOperation,
} from "../../services/utils";
import {
  empty,
  removeOp,
  setOperations,
  updateNote,
  updateOp,
} from "../../context/operations/operationsSlice";
import {
  addCompletedOp,
  setCompletedOperations
} from "../../context/completedOperations/completedOperationsSlice";
import { setUsers } from "../../context/users/usersSlice";
import { emptyTanks, setTanks } from "../../context/tanks/tanksSlice";
import {
  AnalysisDetail,
  AutomaticDetail,
  BottlingDetail,
  CutDetail,
  DestemmingDetail,
  TreatmentDetail,
} from "./Details";
import { ROLES } from "../../constants/base";
import useAuth from "../../hooks/useAuth";
import { setAnalysis } from "../../context/protocols/analysisSlice";
import { setDrugs } from "../../context/substances/drugsSlice";
import { emptyLots, setLots } from "../../context/lots/lotsSlice";
import { setTreatments } from "../../context/protocols/treatmentsSlice";
import {
  addStoredAnalysisResults,
} from "../../context/substances/storedAnalysisResultsSlice";
import { toast } from "react-toastify";
import { useForm, useWatch } from "react-hook-form";
import * as XLSX from "xlsx";

import "./styles/index.scss";
import { format } from "date-fns";
import { setExams } from "../../context/substances/examsSlice";
import { ChatArea } from "../FormComponents";
import { Label } from "recharts";
import { setWineMaking } from "../../context/protocols/wineMakingSlice";
import { computeOperationRow } from "../../services/common";

const OperationsDetail = ({ isMobile }) => {
  const [getLabel] = useLabels();
  const activeWinery = useSelector(selectActiveWinery);
  const { id, type: rawType } = useParams();
  const type = rawType?.toUpperCase?.();
  const operations = useSelector(selectOperations);
  const users = useSelector(selectUsers);
  const tanks = useSelector(selectTanks);
  const lots = useSelector(selectLots);
  const analysis = useSelector(selectAnalysis);
  const drugs = useSelector(selectDrugs);
  const exams = useSelector(selectExams);
  const treatments = useSelector(selectTreatments);
  const winemakingProtocols = useSelector(selectWineMaking);
  const configs = useSelector(selectConfigs);
  const userSockets = useSelector(selectUserSockets);
  const dispatch = useDispatch();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  // const [operation, setOperation] = useState({});
  const operation = useSelector(selectOperationById(Number(id)));

  const [analysisData, setAnalysisData] = useState([]);
  // const [completedOperations2, setCompletedOperations2] = useState([]);
  const completedOperations = useSelector(selectCompletedOperations);
  const [analysisResults, setAnalysisResults] = useState([]);
  const [filteredSubstances, setFilteredSubstances] = useState([]);
  const [step, setStep] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isImport, setIsImport] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [file, setFile] = useState(null);
  const [key, setKey] = useState(0);
  const [analysisState, setAnalysisState] = useState("NOT_SAMPLED"); // [ NOT_SAMPLED, NOT_INSERTED, INSERTING ]
  const pageName = getLabel(`operationTitle${type}`);
  const { auth } = useAuth();
  const role = auth?.role || ROLES.GUEST;
  const storedAnalysisResults = useSelector(selectStoredAnalysisResults) || [];
  // true when current user in a USER and is in the cellarmans list for the given operation
  const isCellarmanEnabled =
    operation?.cellarman_ids?.includes(auth?.user_id) && role === 3;

  const {
    register,
    formState: { errors, isValid },
    getValues,
    setValue,
    setFocus,
    setError,
    clearErrors,
    control,
  } = useForm({
    defaultValues: {},
    mode: "onTouched",
    reValidateMode: "onTouched",
  });

  const completed = useWatch({ control, name: 'completed' }) || {};
  const drops = useWatch({ control, name: 'drop' }) || {};

  // const computeAddOpTypeString = () => {
  //   if (operation?.treatments?.length > 1) {
  //     return getLabel(`operationType${operation.type}`)
  //   }
  //   const protocol_type = operation?.treatments?.[0]?.protocol_type || null;
  //   const subtype = protocol_type ? getLabel(`drugLabelGroup_${protocol_type}`) : null;
  //   return `${getLabel(`operationType${operation.type}`)} ${subtype ? ('(' + subtype + ')'):  ''}`
  // }

  // const computeAdditionalTypeString = () => {
  //   if (['CUT', 'DECANT', 'RACKING', 'ANALYSIS', 'TREATMENT', 'DESTEMMING', 'NEW_LOT'].includes(operation?.type)) return '';
  //   const protocolType = operation?.src_tanks?.[0]?.protocolType || null;
  //   const homogenizationType = protocolType === 'HOMOGENIZATION_REASSEMBLY' ? operation?.src_tanks?.[0]?.homogenizationType || null : null;
    
  //   if (['MICRO', 'MACRO', 'CUSTOM'].includes(protocolType)) return ` (${getLabel(`protocolOXYGENATION_${protocolType}`)})`?.toLowerCase();
  //   // TO DO: aggiungi cappello o altro in omogenizzazione temperatura
  //   if (protocolType !== null && protocolType !== 'ADD') return ` (${getLabel(`protocolType_${protocolType}`)}${homogenizationType ? ` ${getLabel(`protocolHomogenizationMass_${homogenizationType}`)}` : ''}) `?.toLowerCase();
  //   return '';
  // };

  // const computeRecurrentString = () => {
  //   if (!["ANALYSIS", "TREATMENT"].includes(operation?.type)) return "";
  //   const arr = (operation?.type === "TREATMENT" ? treatments : analysis) || [];
  //   const protocolName =
  //     arr?.find((p) => p?.protocols_id === operation?.protocol_id)
  //       ?.protocols_name || "";
  //   const pName = protocolName?.length > 0 ? ` [${protocolName}]` : "";

  //   const customName = operation?.custom_name?.trim() || null;
  //   if (!operation?.repetitive) {
  //     if (customName) return ` #${customName}${pName}`
  //     else return ` #${operation?.id}${pName}`;
  //   }

  //   const current = operation?.relative_id || 0;
  //   const total = operation?.total || 0;

  //   return current > 0 && total > 0
  //     ? ` #${customName || operation?.main_id || operation?.id} (${current}/${total})${pName}`
  //     : "";
  // };

  const loadOperations = async () => {
    const currentOperations = await getOperations(axiosPrivate);
    dispatch(setOperations(currentOperations));
    // console.log("currentOperations", currentOperations);
    // if (currentOperations && currentOperations?.length > 0 && Object.keys(operation)?.length === 0) {
      // setOperation(
      //   currentOperations?.find((operationsDb) => {
      //     return operationsDb.id === Number(id);
      //   }) || {}
      // );
    // }
  };

  const loadUsers = async () => {
    const currentUsers = await getUsers(axiosPrivate);
    dispatch(setUsers(currentUsers));
  };

  const loadTanks = async () => {
    const currentTanks = await getTanks(activeWinery?.id, axiosPrivate);
    dispatch(setTanks(currentTanks));
  };

  const loadDrugs = async () => {
    const currentDrugs = await getDrugs(axiosPrivate);
    dispatch(setDrugs(currentDrugs));
  };

  const loadExams = async () => {
    const currentExams = await getExams(axiosPrivate);
    dispatch(setExams(currentExams));
  };

  const loadTreatments = async () => {
    const currentTreatments = await getProtocols("treatment", axiosPrivate);
    dispatch(setTreatments(currentTreatments));
  };

  const loadProtocols = async () => {
    const loadedProtocols = await getProtocols("winemaking", axiosPrivate);
    dispatch(setWineMaking(loadedProtocols));
  };

  const loadLots = async () => {
    const currentLots = await getLots(activeWinery?.id, axiosPrivate);
    dispatch(setLots(currentLots));
  };

  const loadAnalysis = async () => {
    const currentAnalysis = await getProtocols("analysis", axiosPrivate);
    dispatch(setAnalysis(currentAnalysis));
  };

  const loadAnalysisState = async () => {
    if (analysisState !== "NOT_SAMPLED") return;
    if (operation?.completion_date) setAnalysisState("STORED");
    else {
      if (operation?.repetitive) {
        const isSample =
          analysisResults?.[analysisResults?.length - 1]?.results === null;
        if (Number(operation?.relative_id) - Number(operation?.completed) > 1)
          setAnalysisState("NOT_SAMPLED");
        else if (
          isSample &&
          analysisResults?.length >
            operation?.src_tanks?.length * Number(operation?.completed)
        ) {
          const anRes = (await getAnalysisResults([id], axiosPrivate)) || [];
          setAnalysisState("NOT_INSERTED");
        } else setAnalysisState("NOT_SAMPLED");
      } else {
        // console.log('quiii', analysisResults, operation?.src_tanks?.length)
      }
    }
    // console.log(analysisState, 'anStat')
  };

  useEffect(() => {
    if (operation?.type !== 'ANALYSIS') return;
    const tmp = [];
    
    const analysisArray = [...operation?.treatments || []];
    const processedTanks = new Set();
    
    const isOnTank = operation?.on_tank;
    analysisArray
      ?.sort((a, b) => a?.tank_id - b?.tank_id)
      ?.forEach((an, i) => {
        const source = operation?.on_tank
          ? tanks?.find((t) => t.id == an?.tank_id)
          : lots?.find((l) => l.id == an?.batch_id);
        const index = tmp?.findIndex((t) => t?.substance_name === an?.substance_name && (isOnTank ? (t.tank_id == an?.tank_id) : (t.batch_id == an?.batch_id)));
        if (index > -1) {
          const items = tmp[index].items;
          items.push({ unit: an?.unit, min_range: an?.min_range, max_range: an?.max_range, colors: ["ROSE"]});
          tmp[index].items = items
          return true;
        }
        const isTankFirst = !processedTanks.has(an?.tank_id || an?.batch_id);
        
        tmp.push({
          ...an, 
          batch_name: source?.batch_name,
          isTankFirst: isTankFirst, // true only if not already processed
          collection_date: isTankFirst ? an?.collection_date : null,
          user_id: isTankFirst ? an?.user_id : null,
          src_name: isTankFirst ? source?.name : null,
          temperature: an?.temperature,
          enableRange: i < filteredSubstances?.analysis?.length,
          isShowFirstLineData: isTankFirst, //obj.isTankFirst,    // TO DO, if ok remove isShowFirstLineData and use isTankFirst i % rowCount === 0;
          // relative_id = Math.floor(tmpData?.length / (tanksLen * anLen)) + 1;
          // endOfRepBorder: true,// i % rowCount === 0,
          endOfSrcNameBorder: isTankFirst,
          opType: "ANALYSIS",
          items: [{ unit: an?.unit, min_range: an?.min_range, max_range: an?.max_range, colors: ["RED"]}],
        });
        
        processedTanks.add(an?.tank_id || an?.batch_id); // mark this tank_id (or batch_id) as processed
      });

      setAnalysisData(tmp);
  }, [operation, filteredSubstances]);

  const customIdInvalidAnalysisResults = 'custom-id-invalid-analysis-results';
  const customIdInvalidSrcTank = 'custom-id-invalid-src-tank';
  const [isInvalidSrcTank, setIsInvalidSrcTank] = useState(false);

  const isSrcTanksStillValid = () => {
    if (!Array.isArray(operation?.src_tanks) || operation?.src_tanks?.length === 0 || operation?.completion_date || lots?.length > 0 || tanks?.length > 0) {
      return;
    }

    let isSrcTankError = false;
    operation?.src_tanks?.forEach((t) => {
      if (["DESTEMMING"].includes(operation?.type)) {
        const lot = lots?.find((ll) => ll?.id === t?.batch_id);
        if (lot === undefined || lot?.actual_quantity <= 0) {
          isSrcTankError = true;
          return false;
        }
      } else if (["NEW_LOT"].includes(operation?.type)) {
        const lot = operation?.src_tanks?.[0];
        if (lot === undefined || !lot?.quantity) {
          isSrcTankError = true;
          return false;
        }
      } else {
        const tank = tanks?.find((tt) => tt?.id === Number(t?.tank_id));
        if (tanks?.length > 0 && (tank === undefined || tank?.quantity <= 0 || !tank?.batch_name)) {
          isSrcTankError = true;
          return false;
        }
      }
    });
      
    if (isSrcTankError) {
      toast(getLabel("toast_srcTankNowEmpty"), {
        toastId: customIdInvalidSrcTank,
        type: toast.TYPE.ERROR,
        isLoading: false,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsInvalidSrcTank(true);
    } else {
      toast.dismiss(customIdInvalidSrcTank);
    }
  }

  const initData = async () => {
    const promiseArray = [];

    if (operations?.length === 0) {
      promiseArray.push(loadOperations());
    }
    if (users?.length === 0) {
      promiseArray.push(loadUsers());
    }
    if (tanks?.length === 0) {
      promiseArray.push(loadTanks());
    }
    if (lots?.length === 0) {
      promiseArray.push(loadLots());
    }
    if (analysis?.length === 0) {
      promiseArray.push(loadAnalysis());
    }
    if (drugs?.length === 0) {
      promiseArray.push(loadDrugs());
    }
    if (exams?.length === 0) {
      promiseArray.push(loadExams());
    }
    if (treatments?.length === 0) {
      promiseArray.push(loadTreatments());
    }
    if (winemakingProtocols?.length === 0) {
      promiseArray.push(loadProtocols());
    }

    promiseArray.push(loadCompletedOperations());
    return Promise.all(promiseArray);
  };

  useEffect(() => {
    initData();
  }, []);

  useEffect(() => {
    loadAnalysisState();
  }, [analysisResults]);


  useEffect(() => {
    if (["TREATMENT", "ANALYSIS", "CLEANING"].includes(operation?.type)) filterDisabledSubstances();
  }, [operation, exams, drugs]);

  useEffect(() => {
    // if (operations?.length === 0) {
    //   loadOperations();
    // }
    // if (completedOperations?.length === 0) {
    //   loadCompletedOperations();
    // }

    // if (operations && operations?.length > 0 && Object.keys(operation)?.length === 0) {
    //   setOperation(
    //     operations.find((operationsDb) => {
    //       return operationsDb.id === Number(id);
    //     }) || {}
    //   );
    // }

    // if (completedOperations?.length > 0 && Object.keys(operation)?.length === 0) {
    //   setOperation(
    //     completedOperations.find((operationsDb) => {
    //       return operationsDb.id === Number(id);
    //     }) || {}
    //   );
    // }

    isSrcTanksStillValid();
    // console.log(completedOperations, id)
  }, [id, completedOperations, operation]);

  const loadCompletedOperations = async () => {
    const singleCompletedOperation = await getOperationById(axiosPrivate, id);

    if (
      !singleCompletedOperation ||
      singleCompletedOperation?.length === 0 ||
      singleCompletedOperation?.[0]?.completion_date === null
    ) {
      const analysisInStore =
        storedAnalysisResults?.filter((stored) => stored.operation_id === id) ||
        [];
      
      if (analysisInStore?.length === 0) {
        const anRes = (await getAnalysisResults([id], axiosPrivate)) || [];
        const anResults = anRes?.sort((a, b) => a?.id - b?.id);
        
        if (anResults?.length > 0 && anResults?.[0]?.results !== null) {
          setAnalysisResults(anResults);
          dispatch(addStoredAnalysisResults(anResults));
          // console.log('not found')
        } else if (anResults?.length > 0 && anResults?.[0]?.results === null) {
          setAnalysisState("NOT_INSERTED");
          setAnalysisResults(anResults);
        }
      } else {
        // console.log('found')
        setAnalysisResults(analysisInStore || []);
      }
      // return;
    } else if (
      singleCompletedOperation?.[0]?.completion_date !== null
      
    ) {
      // setCompletedOperations2(singleCompletedOperation);
      // dispatch(setCompletedOperations(singleCompletedOperation));
      dispatch(addCompletedOp(singleCompletedOperation?.[0]));
      if (singleCompletedOperation[0]?.type !== "ANALYSIS" &&
        singleCompletedOperation[0]?.type !== "TREATMENT") return;
    }
    // else if (singleCompletedOperation[0]?.type !== 'ANALYSIS' && singleCompletedOperation[0]?.type !== 'TREATMENT') return;

    let operation_id = null;
    if (singleCompletedOperation[0]?.repetitive) {
      // get all the related operations
      const relatedOperations = await getOperationsByMainId(axiosPrivate, id);
      const isMain = singleCompletedOperation[0]?.main_id === null;
      operation_id = isMain
        ? id
        : relatedOperations?.find((o) => o.id == id)?.main_id;
      const singleOp =
        (isMain
          ? relatedOperations?.filter((o) => o.id == id)
          : singleCompletedOperation) || null;
      // if (singleOp !== null) setCompletedOperations2(singleOp);
    } else {
      operation_id = singleCompletedOperation[0]?.id;
      // if (operation_id) setCompletedOperations2(singleCompletedOperation);
      // if (Object.keys(operation)?.length === 0) setOperation(singleCompletedOperation?.[0] || {});   // TO DO se la decommento non ottengo src_tanks e dest_tanks
    }

    const analysisInStore =
      operation_id === null
        ? []
        : storedAnalysisResults?.filter(
            (stored) =>
              stored.operation_id === id ||
              stored.operation_id === operation_id[0]
          ) || [];
    // console.log('analysisInStore', analysisInStore)
    // console.log('storedAnalysisResults', storedAnalysisResults)

    if (analysisInStore?.length === 0) {
      const anRes =
        (await getAnalysisResults([operation_id], axiosPrivate)) || [];
      const anResults = anRes?.sort((a, b) => a?.id - b?.id);

      if (anResults?.length > 0 && anResults?.[0]?.results !== null) {
        setAnalysisResults(anResults);
        dispatch(addStoredAnalysisResults(anResults));
        // console.log('not found 2')
      } else if (anResults?.length > 0 && anResults?.[0]?.results === null) {
        setAnalysisState("NOT_INSERTED");
      }
    } else {
      // console.log('found 2')
      setAnalysisResults(analysisInStore || []);
    }
  };

  const filterDisabledSubstances = () => {
    if (type === 'CLEANING') {
      const ops = operation?.treatments || [];
      const name = winemakingProtocols?.find(t => operation?.winemaking_protocol_id == t?.id)?.name || "";
      const tmp = { name: name, operations: [...ops]?.sort((a, b) => a?.day - b?.day) }
      setFilteredSubstances(tmp);
      return tmp;
    } else {
      const data = type === 'TREATMENT' ? treatments : analysis;
      const tmp = { ...(data?.find(
        (a) => a.protocols_id == operation?.protocol_id
      ) || {})};
      if ((type === 'ANALYSIS' && !tmp?.analysis) || (type === 'TREATMENT' && !tmp?.drugs)) return {};
    
      const tmpArray = [];

      const srcArr = Array.isArray(
        type === 'ANALYSIS' ? tmp?.analysis :
        tmp?.drugs
      ) ? [
        ...(type === 'ANALYSIS' ? tmp?.analysis :
          tmp?.drugs)
      ] : [];

      const srcSubstancesArr = Array.isArray(type === 'ANALYSIS' ? exams : drugs)
        ? [...(type === 'ANALYSIS' ? exams : drugs)]
        : [];

      if (Array.isArray(operation?.treatments) && operation?.treatments?.length > 0 && srcArr?.length > 0) {
        // substance_id that have been disable for this application
        const onlyRemoved = srcSubstancesArr
        ?.filter((s) => operation?.treatments?.some((tt) => tt?.substance_id === s?.id && tt?.removed === true))
        ?.map((s) => { return {
          ...s,
          substance_id: s?.id,
          substance_name: s?.name,
          removed: true,
        }});
        const onlyNotRemoved = srcSubstancesArr
        ?.filter((s) => operation?.treatments?.some((tt) => tt?.substance_id === s?.id && (!tt?.removed || tt?.removed === false)))
        ?.map((s) => { return {
          ...s,
          substance_id: s?.id,
          substance_name: s?.name,
          // drug_batch_number: operation?.treatments?.find((tt) => tt?.substance_id === s?.id && (!tt?.removed || tt?.removed === false))?.drug_batch_number || ""
          ...(operation?.treatments?.find((tt) => tt?.substance_id === s?.id && (!tt?.removed || tt?.removed === false)))
        }});
        tmpArray.push(...onlyRemoved, ...onlyNotRemoved);
      }
      
      if (type === 'ANALYSIS') {
        tmp.analysis = operation?.treatments?.length > 0 ? tmpArray : srcArr;
      } else {
        tmp.drugs = tmpArray;
      }
    
      setFilteredSubstances(tmp);
      
      return tmp;
    }
  }

  const addChatNote = (newNote) => {
    if (!operation?.id) return;
  
    const updatedChatNotes = Array.isArray(operation.chat_notes)
      ? [...operation.chat_notes, newNote]
      : [newNote];
  
    // Assicura che timestamp sia una stringa ISO (serializzabile)
    const serializedNotes = updatedChatNotes.map((note) => ({
      ...note,
      timestamp: typeof note.timestamp === 'string'
        ? note.timestamp
        : new Date(note.timestamp).toISOString(),
    }));

    dispatch(updateNote({
      id: operation.id,
      chat_notes: serializedNotes,
    }));
  };

  const getInfoByType = (type) => {
    switch (type) {
      case "NEW_LOT":
      case "DESTEMMING":
        return (
          <div className="operation_destemming_wrapper">
            <DestemmingDetail
              operation={operation}
              users={users}
              tanks={tanks}
              lots={lots}
              completed={completed}
              drops={drops}
              // batchData={lots?.find?.((lot) => {
              //   return Number(lot?.id) === Number(operation?.batch_id_in);
              // })}
              // batchData={operation?.completion_date === null ? operation?.src_tanks?.[0]?.preOperation?.batch : operation?.src_tanks?.[0]?.postOperation?.batch}
              configs={configs}
              register={register}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              axiosPrivate={axiosPrivate}
              dispatch={dispatch}
              user_id={auth?.user_id}
              isNewLot={type === "NEW_LOT"}
              isMobile={isMobile}
            />
          </div>
        );
      
      case "CUT":
      case "CLOSING":
      case "DECANT":
      case "RACKING":
      case "FILTERING":
        return (
          <div className="operation_cut_wrapper">
            <CutDetail
              operation={operation}
              completed={completed}
              drops={drops}
              users={users}
              lots={lots}
              tanks={tanks}
              configs={configs}
              type={type}
              register={register}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              axiosPrivate={axiosPrivate}
              dispatch={dispatch}
              user_id={auth?.user_id}
              isMobile={isMobile}
            />
          </div>
        );
      case "TREATMENT":
      case "CLEANING":
        return (
          <div className="operation_treatment_wrapper">
            <TreatmentDetail
              type={type}
              operation={operation}
              completed={completed}
              register={register}
              errors={errors}
              users={users}
              tanks={tanks}
              lots={lots}
              drugs={drugs}
              treatments={filteredSubstances}
              configs={configs}
              getValues={getValues}
              setValue={setValue}
              axiosPrivate={axiosPrivate}
              dispatch={dispatch}
              user_id={auth?.user_id}
              isMobile={isMobile}
            />
          </div>
        );
      case "ANALYSIS":
        return (
          <div className="operation_analysis_wrapper">
            <AnalysisDetail
              data={analysisData}
              operation={operation}
              register={register}
              users={users}
              tanks={tanks}
              lots={lots}
              configs={configs}
              results={analysisResults?.sort((a, b) => a.id - b.id)}
              analysis={filteredSubstances}
              isCellarmanEnabled={
                isCellarmanEnabled &&
                !(
                  operation?.repetitive &&
                  Number(operation?.completed) <
                    Number(operation?.relative_id) - 1
                )
              }
              registerComplete={register}
              errorsComplete={errors}
              controlComplete={control}
              analysisState={analysisState}
              getValues={getValues}
              setValue={setValue}
              axiosPrivate={axiosPrivate}
              dispatch={dispatch}
              user_id={auth?.user_id}
              isMobile={isMobile}
              key={key}
            />
          </div>
        );
      case "ADD":
      case "ENZYME":
      case "SO2":
      case "HOMOGENIZATION_MASS":
      case "NITROGEN":
      case "INOCULATION":
      case "BOIS":
      case "TANNISSAGE":
      case "OXYGENATION":
      case "STABILIZATION_STATIC":
      case "STABILIZATION_DYNAMIC":
      case "STABILIZATION_RESIN":
        return (
          <div className="operation_automatic_wrapper">
            <AutomaticDetail
              type={type}
              operation={operation}
              completed={completed}
              users={users}
              tanks={tanks}
              lots={lots}
              drugs={drugs}
              configs={configs}
              register={register}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              axiosPrivate={axiosPrivate}
              dispatch={dispatch}
              user_id={auth?.user_id}
              isMobile={isMobile}
            />
          </div>
        );
      case "BOTTLING":
        return (
          <div className="operation_bottling_wrapper">
            <BottlingDetail
              operation={operation}
              completed={completed}
              drops={drops}
              users={users}
              lots={lots}
              tanks={tanks}
              configs={configs}
              register={register}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              axiosPrivate={axiosPrivate}
              dispatch={dispatch}
              user_id={auth?.user_id}
              isMobile={isMobile}
            />
          </div>
        );
      default:
        return (
          <div className="operation_error">{getLabel("genericError")}</div>
        );
    }
  };

  const requestPDF = async () => {
    const data = {
      type: "operationDetail",
      title: getLabel("operationDetail"),
      rows: operations?.map((operation) => operation.id),
      columns: [
        getLabel("priority"),
        getLabel("operationType"),
        getLabel("operationSrcTank"),
        getLabel("operationDestTank"),
        getLabel("cellarman"),
        getLabel("expiringDate"),
        getLabel("operationNotes"),
      ],
      headers: [
        "priority",
        "type",
        "src_tanks",
        "dest_tanks",
        "cellarman_ids",
        "expire_date",
        "note",
      ],
      winery_name: activeWinery?.name || "",
      order_by: "expire_date",
      order_sort: "desc",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language:
        navigator.languages?.length > 0
          ? navigator.languages[0]?.replace("_", "-")
          : "it-IT",
    };

    // await getPDF(data, axiosPrivate);
  };

  const requestLabelPDF = async () => {
    const data = {
      pdf_type: "analysisLabel",
      type: "operations",
      additionalData: {
        subtitle: getLabel("analysisLabel"),
      },
      title: `${activeWinery?.name || ""} AN-${operation?.id}`,
      rows: [[operation?.id]],
      columns: [
        getLabel("analysisName"),
        getLabel("unit"),
        getLabel("substanceRange"),
      ],
      headers: ["analysis_name", "unit", "analysis_min"],
      winery_name: activeWinery?.name || "",
      order_by: "expire_date",
      order_sort: "desc",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      language:
        navigator.languages?.length > 0
          ? navigator.languages[0]?.replace("_", "-")
          : "it-IT",
    };

    await getPDF(
      data,
      axiosPrivate,
      getLabel("pdfType_ANALYSIS") + (operation?.id ? `-${operation?.id}` : "")
    );
  };

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleManualAddOpenModal = () => {
    setIsManual(true);
    handleOpenModal();
  };

  const handleManualAddConfirmModal = () => {
    setIsManual(false);
    handleCloseModal();
    sendData();
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setStep(0);

    if (isManual) setIsManual(false);
  };

  const handleImportConfirmModal = () => {
    if (file === null) {
      setError("file", {
        type: "manual",
        message: getLabel("errorOperationExcelFileImport"),
      });
      return;
    } else {
      if (
        file.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setError("file", {
          type: "filetype",
          message: getLabel("errorOperationExcelFileImportFormat"),
        });
        return;
      }
    }

    try {
      importExcel();
    } catch (err) {
      console.log(err);
      setError("file", {
        type: "filetype",
        message: getLabel("errorOperationExcelFileImportError"),
      });
      return;
    }

    if (isImport) {
      setAnalysisState("INSERTING");
      setIsImport(false);
    }
    handleCloseModal();
  };

  const handleFormSubmit = async () => {
    await removeOperation();
    handleCloseModal();
  };

  const importExcel = () => {
    if (file) {
      const reader = new FileReader();
      const analysisExams = operation?.treatments || [];
  
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: "array" }); // <- updated type
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
  
        const analysisLen = analysisExams?.length - operation?.treatments?.length;
  
        const columnStartIndex =
          !isImport || !operation?.repetitive
            ? 0
            : analysisLen *
              (operation?.src_tanks?.length || 1) *
              (Number(operation?.completed) || 1);
  
        const tankId = getLabel("tank_id");
        const batchId = getLabel("batch_id");
        const substanceId = getLabel("analysisSubstanceId");
        const value = getLabel("examResult");
  
        json?.forEach((row, i) => {
          const tank_id = row?.[tankId];
          const batch_id = row?.[batchId];
          const substance_id = row?.[substanceId];
          const measured_value = row?.[value];
        
          if (!measured_value) return;
        
          
          const indexInData = analysisData?.findIndex(
            (ad) =>
              ad?.batch_id === batch_id &&
              (!operation?.on_tank || ad?.tank_id === tank_id)
          );
          const indexOffset = indexInData + columnStartIndex;
        
          // Set value in "column"
          setValue(`column.${indexOffset}.value`, measured_value);
        
          // Set full tank row
          setValue(`column.tanks.${indexOffset}`, {
            substance_id: substance_id ?? "",
            tank_id: tank_id ?? "",
            batch_id: batch_id ?? "",
            value: measured_value,
          });
        });        
      };
  
      reader.readAsArrayBuffer(file);
    }
  };  

  const removeOperation = async () => {
    const toastId = toast.loading(getLabel("toast_inProgress"), {
      type: toast.TYPE.INFO,
      position: toast.POSITION.BOTTOM_RIGHT,
      exclude: true,
    });

    const response = await deleteOperation(
      operation?.main_id || id,
      axiosPrivate
    );
    const requestPayload = {
      ...(id && { id: operation?.main_id || Number(id) }),
    };

    toast.update(toastId, {
      render: response?.success
        ? getLabel(response?.success, { type: operation?.type || "" })
        : getLabel(response?.error),
      type: !response || response?.error ? toast.TYPE.ERROR : toast.TYPE.SUCCESS,
      isLoading: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 4000,
    });
    console.log('response', response);
    if (response && response?.success) {
      dispatch(removeOp({ id: Number(id) }));
      navigate(`/programming`);
    }
  };

  const renderDetail = () => {
    const infoComponent = getInfoByType(type);
    return <div className="operation_info_container">{infoComponent}</div>;
  };

  const buildAnalysisPayload = (data, requestPayload) => {
    let isValid = true;
    const analysisData = [];
    const results = data?.column?.tanks || [];

    if (results?.length === 0 && analysisState !== "NOT_SAMPLED") return [];
    operation?.src_tanks?.forEach((tank, i) => {
      const id = Number( tank?.tank_id || tank?.batch_id);
      if (!id && analysisState === "NOT_SAMPLED") return true;    // continue, there are null values
      else if (!id && analysisState !== "NOT_SAMPLED") return [];
      
      const obj = {
        batch_id: tank?.batch_id,
        tank_id: tank?.tank_id,
        analyst: data?.analyst,
        temperature: Number(data?.temperature?.[id]) || null,
      };
      if (analysisState !== "NOT_SAMPLED") {
        const currentTankAnalysisData = results?.filter(t => operation?.on_tank ? (t?.tank_id == id) : (t?.batch_id == id));
        // console.log('id', id, 'results', results, 'currentTankAnalysisData', currentTankAnalysisData, 'operation', operation)
        if (currentTankAnalysisData?.length === 0 ||
          currentTankAnalysisData?.length !== filteredSubstances?.analysis?.length || 
          currentTankAnalysisData?.filter(item => Number(item?.value) === 0)?.length > 0) {

            toast.error(getLabel(operation?.on_tank ? "toast_analysisMissingPerTank" : "toast_analysisMissingPerBatch", {name: tank?.name || tank?.old_batch_name}), {
              toastId: customIdInvalidAnalysisResults,
              isLoading: false,
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 4000,
          });
            isValid = false;
            return false;
          };
          obj.results = currentTankAnalysisData;
        }
      
      analysisData.push(obj);
    });
    requestPayload.analysis = analysisData;
    return isValid;
  };

  const buildDestemmingPayload = (type, data, requestPayload) => {
    const drops = [];
    
    if (data?.drop && typeof data.drop === 'object') {
      Object.entries(data.drop).forEach(([v, d]) => {
        if (d) {
          const tmp = { tank_id: v, quantity: Number(d) || 0 };
          if (type === 'BOTTLING') {
            delete tmp.tank_id;
            tmp.transfer_id = Number(v);
          } else if (type === 'CLOSING') {
            delete tmp.tank_id;
            tmp.close_id = Number(v);
          }
          drops.push(tmp);
        }
      });
    }
    
    // when BOTTLING, tank_id does not exist, so the uniqueness is guaranteed by tank_id = ${tank.bottle_id}_${tank.cap_id}_${tank?.batch_name}
      requestPayload.drop = drops;
  };

  const sendData = async () => {
    const data = getValues();
    // console.log(data, "dataSend", errors);
    // return;
    const requestPayload = {};
    if (operation?.type === "ANALYSIS") {
      
      const errorsNoWarning = (errors?.column || [])?.filter(e => e?.value?.type !== "min" && e?.value?.type !== "max")?.length;  // exclude min/max warnings
      if (errorsNoWarning?.length > 0) return;
        if (!buildAnalysisPayload(data, requestPayload)) {
          console.log('error buildAnalysisPayload')
          return;
        }
    } else if (
      ["DESTEMMING", "CUT", "DECANT", "RACKING", "NEW_LOT", "BOTTLING", "CLOSING"].includes(
        operation?.type
      ) || (operation?.type === "FILTERING" && operation?.start_date)   // FILTERING may have a drop
    ) {
      if (Object.keys(errors)?.length > 0) return;
      buildDestemmingPayload(type, data, requestPayload);
    }

    console.log('requestPayload', requestPayload);
    // return;
    const toastId = toast.loading(getLabel("toast_inProgress"), {
      type: toast.TYPE.INFO,
      position: toast.POSITION.BOTTOM_RIGHT,
      exclude: true,
    });

    const isStabilization = ["STABILIZATION_STATIC", "STABILIZATION_DYNAMIC", "STABILIZATION_RESIN"].includes(operation?.type);
    const isFiltering = operation?.type === "FILTERING";
    const isOperationToBeStarted = (isStabilization || isFiltering) && operation?.start_date === null;
    const response = await (isOperationToBeStarted ?
      startOperation(id, axiosPrivate)
      : completeOperation(id, requestPayload, axiosPrivate));

    toast.update(toastId, {
      render: response?.success
        ? getLabel(response?.success, { type: operation?.type || "" })
        : getLabel(response?.error),
      type: !response || response?.error ? toast.TYPE.ERROR : toast.TYPE.SUCCESS,
      isLoading: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 4000,
    });
    console.log(response);
    if (response && response?.success) {

      const updated_op = response?.updated_data || null;
      if (updated_op && isOperationToBeStarted) {
        dispatch(updateOp(updated_op));
      } else {
        dispatch(removeOp(({ id: Number(id) })));
      }

      if (operation?.type === "ANALYSIS") {
        // dispatch(emptyExams());
      } else if (operation?.type === "CLEANING") {
        dispatch(emptyTanks());
      } else if (
        ["DESTEMMING", "CUT", "RACKING", "DECANT", "NEW_LOT", "BOTTLING"].includes(
          operation?.type
        )
      ) {
        dispatch(emptyLots());
        dispatch(emptyTanks());
      }

      navigate(`/programming/`);
    }
  };

  const sendSampleData = async () => {
    const data = getValues();
    
    const requestPayload = {};
    if (!buildAnalysisPayload(data, requestPayload)) return;
    console.log(requestPayload, 'requestPayload sample');
    // return;
    const toastId = toast.loading(getLabel("toast_inProgress"), {
      type: toast.TYPE.INFO,
      position: toast.POSITION.BOTTOM_RIGHT,
      exclude: true,
    });
    
    const response = await addAnalysisSample(id, requestPayload, axiosPrivate);

    toast.update(toastId, {
      render: response?.success
        ? getLabel(response?.success, { type: operation?.type || "" })
        : getLabel(response?.error),
      type: !response || response?.error ? toast.TYPE.ERROR : toast.TYPE.SUCCESS,
      isLoading: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 4000,
    });
    console.log('response', response);
    if (response && response?.success) {
      
      const updated_op = response?.updated_data || null;
      if (updated_op) {
        dispatch(updateOp(updated_op));
        // setOperation(updated_op);
      } else {
        dispatch(removeOp(({ id: Number(id) })));
        await loadCompletedOperations();
      }

      setIsOpen(false);
      setAnalysisState("NOT_INSERTED");
      // const anResults = (await getAnalysisResults([operation?.main_id || operation?.id], axiosPrivate) || []);
      // const anRes = (await getAnalysisResults([operation?.main_id || operation?.id], axiosPrivate) || []);
      // const anResults = anRes?.sort((a, b) => a?.id - b?.id);
      // console.log(anResults, anResults?.length, operation?.src_tanks?.length, '----');
      // if (anResults?.length === operation?.src_tanks?.length)
      //   setAnalysisState("NOT_INSERTED");
      // navigate(`/programming/`);

      filterDisabledSubstances();

      setKey((prev) => prev + 1);
    }
  };

  const renderInsertAnalysisSample = () => {
    // const isCompleted = true;
    const isCurrentIterationDisabled =
      Number(operation?.relative_id) - Number(operation?.completed) > 1;
    const disabled =
      isCurrentIterationDisabled ||
      (analysisResults?.length <
        Number(operation?.completed) * operation?.src_tanks?.length &&
        (!analysisResults?.results || analysisResults?.results?.length === 0));

    if (disabled)
      return (
        <Tooltip
          variant={"info"}
          html={isInvalidSrcTank ? getLabel("errorSrcTankNowEmpty")
            : getLabel("errorPreviousRecurrOpsNotCompleted")}
          place="right"
          events={["hover"]}
        >
          <CTA
            customClassName={`is_submit ${analysisState === "INSERTING" ? "complete" : "add"}`}
            disabled={disabled}
          >
            {getLabel("addRepetitiveAnalysisSampleOperation")}
          </CTA>
        </Tooltip>
      );
    else
      return (
        <CTA
          customClassName={`is_submit ${analysisState === "INSERTING" ? "complete" : "add"}`}
          onClick={() =>
            operation?.type === "ANALYSIS" ? handleOpen() : sendSampleData()
          }
          disabled={disabled}
        >
          {analysisState === "NOT_SAMPLED"
            ? getLabel("addRepetitiveAnalysisSampleOperation")
            : getLabel("addRepetitiveAnalysisOperation")}
        </CTA>
      );
  };

  const handleImport = () => {
    setIsImport(true);
    handleOpenModal();
  };

  const cancel = () => {
    const column = getValues()?.column?.map((c) => {
      return { value: "" };
    });
    setValue("column", column);
    if (analysisState === "INSERTING") setAnalysisState("NOT_INSERTED");
  };

  const handleExport = () => {
    const data = [];
    const analysisExams = operation?.treatments || [];
    
    operation?.src_tanks?.forEach((tank) => {
      const filteredExams = analysisExams?.filter((e) => e?.batch_id === tank?.batch_id) || [];
      filteredExams?.forEach((an) => {
        // if (operation?.treatments?.find((s) => s?.substance_id == an?.substance_id && s?.removed)) return true;
        const tmp = {};
        tmp[getLabel('tank')] = tank?.name;
        tmp[getLabel('tank_id')] = tank?.tank_id;
        tmp[getLabel('batch')] = tank?.old_batch_name;
        tmp[getLabel('batch_id')] = tank?.batch_id;
        tmp[getLabel('analysisSubstanceId')] = an?.substance_id;
        tmp[getLabel('analysisSubstanceName')] = getLabel(`substance_${an?.substance_name}`);
        tmp[getLabel('substanceRang')] = `${an?.min_range !== null ? String(an?.min_range) || "n/a" : "n/a"} - ${
          an?.max_range !== null ? String(an?.max_range) || "n/a" : "n/a"}`;
        tmp[getLabel('unit')] = an?.unit;
        tmp[getLabel('analysisLabel_id')] =  `AN-${operation?.custom_name || operation?.id}-${tank?.name || tank?.old_batch_name}`;
        tmp[getLabel('examResult')] = "";
        
        data.push(tmp);
      });
    });
    
    const worksheet = XLSX.utils.json_to_sheet(data);
    const wscols = [
      {wch: 13},  // tank
      {wch: 10},  // tank_id
      {wch: 13},  // batch
      {wch: 10},  // batch_id
      {wch: 10},  // analysis id
      {wch: 10},  // analysis name
      {wch: 13},  // analysis range
      {wch: 13},  // unit
      {wch: 20},  // analysis label
      {wch: 15},  // results
    ];
    worksheet['!cols'] = wscols;
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      `${getLabel('pdfType_ANALYSIS')}-${operation?.custom_name || id}_${format(new Date(), configs.shortDateFormat)}.xlsx`
    );
  };

  const renderUpdateButton = () => {
    if (!operation.repetitive ||
      (operation?.repetitive &&
        !operation.main_id &&
        Number(operation?.relative_id) === 1 &&
        Number(operation?.completed) === 0)) return (
      <NavLink to={`/programming/${type}/${id}/update`}>
        <CTA>{getLabel("updateOperation")}</CTA>
      </NavLink>)

    const isRepetitiveAndNotStarted = operation?.repetitive &&
      operation.main_id &&
      Number(operation?.completed) === 0;
    const isRepetitiveAndAlreadyStartedDisable = operation?.repetitive &&
      operation.main_id &&
      Number(operation?.completed) > 0;
    
    const disabled = isRepetitiveAndAlreadyStartedDisable;

    if (disabled)
      return (
      <Tooltip
        variant={"info"}
        html={
          isRepetitiveAndAlreadyStartedDisable ? getLabel("errorRecurrentOpAlreadyStarted")
          : ""
        }
        place="right"
        events={["hover"]}
      >
      <NavLink to={`/programming/${type}/${isRepetitiveAndNotStarted ? operation?.main_id : id}/update`}>
        <CTA disabled={disabled}>{getLabel("updateOperation")}</CTA>
      </NavLink>
      </Tooltip>
    )
    return (
      <NavLink to={`/programming/${type}/${isRepetitiveAndNotStarted ? operation?.main_id : id}/update`}>
        <CTA>{getLabel("updateOperation")}</CTA>
      </NavLink>)
  }

  const renderButtons = (isSubmit = false) => {
    const analysisResultsPerOperationId = analysisResults?.filter(
      (an) => an?.operation_id === operation?.id
    );
    // console.log('analysisResultsPerOperationId', analysisResultsPerOperationId, analysisState, analysisResults)
    if (isSubmit &&
      ["NOT_SAMPLED"]?.includes(analysisState) &&
      operation?.type === "ANALYSIS" &&
      // operation?.repetitive &&
      (analysisResultsPerOperationId?.length < operation?.src_tanks?.length ||
        analysisResultsPerOperationId?.length === 0)
    ) {
      return renderInsertAnalysisSample();
    }
    const completed = getValues("completed") || [];
    
    const repetitiveDisabled =
      operation?.repetitive &&
      Number(operation?.completed) < Number(operation?.relative_id) - 1;
    const checkboxDisabled = operation?.type === 'BOTTLING' ? 
      completed?.[operation?.dest_tanks?.[0]?.drop_batch_id] === false 
      : Array.isArray(completed) ? !completed?.every(
      (v) => v === true
    ) : true;
    const dropDisabled =
      operation?.type === "DESTEMMING" &&
      (getValues("drop")?.filter((c) => c) || [])?.length <
        operation?.dest_tanks?.length;
    const analysisNum =
      analysisState === "INSERTING"
        ? analysis?.find((a) => a.protocols_id == operation?.protocol_id)
            ?.analysis?.length || 0
        : 0;

    const repetitiveIterationDisabled =
      analysisState === "INSERTING"
        ? operation?.repetitive &&
          ((getValues("column")?.filter((c) => c.value) || []).length <
            analysisNum ||
            (errors?.column?.filter((c) => c.value) || []).length > 0)
        : false;

    const isCompleted = operation?.completion_date !== null;
    // TO DO: campionamento e dopo analisi tutto in fila, ho il pulsante disabilitato
    const disabled =
      isCompleted ||
      repetitiveDisabled ||
      checkboxDisabled ||
      dropDisabled ||
      repetitiveIterationDisabled;

    const isStabilization = ["STABILIZATION_STATIC", "STABILIZATION_DYNAMIC", "STABILIZATION_RESIN"].includes(operation?.type);
    const isFiltering = operation?.type === "FILTERING";
    const isOperationStarted = (isStabilization || isFiltering) && operation?.start_date !== null;

    if (isSubmit && (role === 3 || (role === ROLES.CLIENT &&
      users?.filter((u) => u?.type === "USER")?.length ===
        0)) && operation?.completion_date == null) {
      if (disabled) return (<div className="operation_info_container_row">
        <Tooltip
          variant={"info"}
          html={
            isInvalidSrcTank ? getLabel("errorSrcTankNowEmpty")
            : isCompleted
              ? getLabel("errorOpsCompleted")
              : repetitiveDisabled
              ? getLabel("errorPreviousRecurrOpsNotCompleted")
              : checkboxDisabled
              ? getLabel("errorNotAllCheckboxCompleted")
              : repetitiveIterationDisabled
              ? getLabel("errorNotAllAnalysisCompleted")
              : ""
          }
          place="top"
          events={["hover"]}
          customClassName={"is_submit"}
        >
          <CTA customClassName={"complete is_submit"} disabled={disabled}>
            {isStabilization
              ? getLabel(isOperationStarted ? "endStabilizationOperation" : "startStabilizationOperation") 
              : isFiltering
              ? getLabel(isOperationStarted ? "endFilteringOperation" : "startFilteringOperation") 
              : operation?.type === "ANALYSIS"
                ? getLabel("completeRepetitiveAnalysisOperation")
                : getLabel("completeOperation")}
          </CTA>
        </Tooltip>
      </div>)
    else return (<div className="operation_info_container_row"><CTA
        customClassName={`${analysisState === "INSERTING" ? "complete" : "add"} is_submit`}
        onClick={() =>
          operation?.type === "ANALYSIS" ? handleOpen() : sendData()
        }
        disabled={disabled}
      >
        {isStabilization
          ? getLabel(isOperationStarted ? "endStabilizationOperation" : "startStabilizationOperation") 
          : isFiltering
          ? getLabel(isOperationStarted ? "endFilteringOperation" : "startFilteringOperation") 
          : operation?.type === "ANALYSIS"
            ? analysisState === "INSERTING"
              ? getLabel("completeRepetitiveAnalysisOperation")
              : getLabel("addRepetitiveAnalysisOperation")
                : getLabel("completeOperation")}
      </CTA></div>)
    }

    if (disabled)
      return (
        <>
          {operation?.type === "ANALYSIS" && analysisState === "INSERTING" && (
            <CTA onClick={cancel} disabled={false}>
              {getLabel("deny")}
            </CTA>
          )}
          {operation?.type === "ANALYSIS" && (
            <Tooltip
              variant={"info"}
              html={
                isInvalidSrcTank ? getLabel("errorSrcTankNowEmpty")
                : isCompleted
                  ? getLabel("errorOpsCompleted")
                  : repetitiveDisabled
                  ? getLabel("errorPreviousRecurrOpsNotCompleted")
                  : checkboxDisabled
                  ? getLabel("errorNotAllCheckboxCompleted")
                  : repetitiveIterationDisabled
                  ? getLabel("errorNotAllAnalysisCompleted")
                  : ""
              }
              place="right"
              events={["hover"]}
            >
              {operation?.on_tank && (
                <CTA customClassName={"complete"} disabled={disabled}>
                  {getLabel("addRepetitiveAnalysisOperationExcel")}
                </CTA>
              )}
            </Tooltip>
          )}  
        </>
      );
    else
      return (
        <>
          {operation?.type === "ANALYSIS" && analysisState === "INSERTING" && (
            <CTA onClick={cancel} disabled={false}>
              {getLabel("deny")}
            </CTA>
          )}
          {operation?.type === "ANALYSIS" && operation?.on_tank && (
            <CTA
              onClick={handleImport}
              customClassName={
                analysisState === "INSERTING" ? "complete" : "add"
              }
              disabled={analysisState !== "NOT_INSERTED"}
            >
              {getLabel("addRepetitiveAnalysisOperationExcel")}
            </CTA>
          )}
          {operation?.type === "ANALYSIS" && operation?.on_tank && (
            <CTA onClick={requestLabelPDF}>
              {getLabel("printAnalysisOperationLabel")}
            </CTA>
          )}
        </>
      );
  };

  const handleOpen = () => {
    if (analysisState === "NOT_SAMPLED") {
      handleOpenModal();
      // setAnalysisState('NOT_INSERTED');
    } else if (analysisState === "NOT_INSERTED") {
      setAnalysisState("INSERTING");
    } else if (analysisState === "INSERTING") {
      handleManualAddOpenModal();
    }
    //  else if (analysisState === "INSERTED") {
    //   sendData();
    // }
  };

  const renderNavMenu = () => {
    const navClickHandler = () => {
      window.history.back();
    };
    return (
      <div className="primary_container_menu">
        <div className="primary_container_row">
          <Button arrowDirection="left" onClick={navClickHandler} />
          <div className="title_container">
            <h2>
              {
              // pageName +
                computeOperationRow(operation, treatments, analysis, getLabel)

                // // type === 'ADD' ? computeAddOpTypeString() : 
                // (computeAdditionalTypeString() +
                // computeRecurrentString())
              }
            </h2>
          </div>
        </div>
        <div className="primary_container_row ctas">
          {operation?.completion_date === null &&
            (role === ROLES.USER ||
              (role === ROLES.CLIENT &&
                users?.filter((u) => u?.type === "USER")?.length === 0)) &&
            // ["ANALYSIS", "TREATMENT"].includes(operation?.type) &&
            // operation?.completion_date === null &&
            renderButtons()}
          {role === ROLES.CLIENT && operation?.completion_date === null && (
            <>
            {renderUpdateButton()}
              <NavLink to={`/programming/${type}/${id}/duplicate`}>
                <CTA>{getLabel("copyOperation")}</CTA>
              </NavLink>

              <CTA onClick={handleOpenModal}>{getLabel("deleteOperation")}</CTA>
              <ConfirmationModal
                isOpen={isOpen}
                onConfirm={handleFormSubmit}
                onClose={handleCloseModal}
                description={getLabel(
                  operation?.repetitive
                    ? "modalDeleteRepetitiveOperationDescription"
                    : "modalDeleteOperationDescription",
                  {
                    type: getLabel("operationType" + operation?.type),
                  }
                )}
              ></ConfirmationModal>
            </>
          )}
          {role === ROLES.USER &&
            operation?.completion_date === null &&
            ["ANALYSIS", "TREATMENT"].includes(operation?.type) && (
              <>
                <ConfirmationModal
                  isOpen={isOpen}
                  onConfirm={
                    isManual
                      ? handleManualAddConfirmModal
                      : !isImport
                      ? sendSampleData
                      : handleImportConfirmModal
                  }
                  onClose={handleCloseModal}
                  description={
                    isManual
                      ? getLabel("modalNewAnalysisAnalystAdditional")
                      : !isImport
                      ? getLabel("modalNewAnalysisExamAdditional")
                      : getLabel("modalNewAnalysisExamExcelAdditional")
                  }
                  isOperationRecap={true}
                  errors={errors}
                  getValues={getValues}
                  isAnalysis={true}
                  setError={setError}
                  clearErrors={clearErrors}
                  totalStep={
                    isManual
                      ? 0
                      : !isImport
                      ? operation?.src_tanks?.length - 1
                      : 0
                  }
                  step={step}
                  setStep={setStep}
                  type={
                    isManual ? "ANALYST" : !isImport ? "" : "EXCEL_ANALYSIS"
                  }
                >
                  <OperationRecap
                    type={
                      isManual
                        ? "ANALYST"
                        : !isImport
                        ? "ANALYSIS"
                        : "EXCEL_ANALYSIS"
                    }
                    control={control}
                    register={register}
                    getValues={getValues}
                    setValue={setValue}
                    setError={setError}
                    errors={errors}
                    configs={configs}
                    lots={lots}
                    tanks={tanks}
                    totalStep={operation?.src_tanks?.length - 1}
                    step={step}
                    setStep={setStep}
                    setFocus={setFocus}
                    src_tanks={operation?.src_tanks}
                    setFile={setFile}
                    columnStartIndex={
                      !isImport
                        ? 0
                        : Object.keys(analysis?.[0]?.analysis || {})?.length *
                          (operation?.src_tanks?.length || 1)
                    }
                  />
                </ConfirmationModal>
              </>
            )}
          <CTA onClick={requestPDF}>{getLabel("print")}</CTA>
          {operation?.completion_date === null &&
            operation?.type === "ANALYSIS" && (
              <CTA onClick={handleExport}>
                {getLabel("operationExcelExport")}
              </CTA>
            )}
          {operation?.completion_date === null &&
            operation?.type === "ANALYSIS" && (
              <CTA onClick={handleImport}>
                {getLabel("operationExcelImport")}
              </CTA>
            )}
        </div>
      </div>
    );
  };

  const storeNote = async (
    axiosPrivate,
    dispatch,
    setValue,
    getValues,
    getLabel,
    operation,
    user_id,
    userSockets,
    users,
    addChatNote,
  ) => {
    const newNote = getValues("new_note") || "";
    if (!newNote || newNote?.length === 0) return;
    const userSocketsTmp = [...userSockets];

    const toastId = toast.loading(getLabel("toast_inProgress"), {
      type: toast.TYPE.INFO,
      position: toast.POSITION.BOTTOM_RIGHT,
      exclude: true,
    });
    const requestPayload = { message: newNote };
    const response = await addOperationNote(
      operation?.id,
      requestPayload,
      axiosPrivate
    );

    toast.update(toastId, {
      render: response?.success
        ? getLabel(response?.success, { name: "" || "" })
        : getLabel(response?.error),
      type: !response || response?.error ? toast.TYPE.ERROR : toast.TYPE.SUCCESS,
      isLoading: false,
      position: toast.POSITION.BOTTOM_RIGHT,
      autoClose: 4000,
    });
    
    if (response && response?.success) {
      const user_ids = new Set();
      user_ids.add(user_id);
      user_ids.add(...operation?.cellarman_ids);

      if (response.success) {
        // dispatch(empty());
        setValue("new_note", "");

        const tmpNote = 
        {
          "message": newNote,
          "from_user_id": user_id,
          "user_id": user_id,
          "timestamp": new Date(),
        };

        addChatNote(tmpNote);
      }
    }
  };

  return (
    <div className="primary_container">
      <div className="primary_container_top">
      <SecondaryBar breadCrumb={[{ label: getLabel("programmingNavLink"), link: "/programming" }, pageName]} />
      {renderNavMenu()}
      </div>
        <div className="primary_container_bottom mt_10">
        {renderDetail()}
        {((role === 3 || (role === ROLES.CLIENT &&
        users?.filter((u) => u?.type === "USER")?.length ===
          0)) && operation?.completion_date == null) && renderButtons(true)}
        <div className="operation_info_container_row">
          <ChatArea
            name="chat"
            register={register}
            label={getLabel("lotNotes")}
            placeholder={getLabel("lotNotesPlaceholder")}
            users={users}
            user_id={auth?.user_id}
            // tooltip={getLabel("lotNotesTooltip")}
            configs={configs}
            operation={operation}
            storeNote={() =>
              storeNote(
                axiosPrivate,
                dispatch,
                setValue,
                getValues,
                getLabel,
                operation,
                auth?.user_id,
                userSockets,
                users,
                addChatNote,
              )
            }
          />
        </div>
        <div className="operation_info_container_row additional">
          <Label label={getLabel("demandant")}>
            {users?.find?.(
              (user) => Number(user.id) === Number(operation?.user_id)
            )?.username || ""}
          </Label>
          <Label label={getLabel("updateDate")}>
            {format(new Date(operation?.update_date || null), configs.dateFormat)}
          </Label>
        </div>
      </div>
    </div>
  );
};

export default OperationsDetail;
